<template>
    <div>
      <Navbar />
      <Header/>
      <Content/>
      <Footer/>
    </div>
  </template>
  
  <script>
  import Navbar from '@/components/Navbar.vue'
  import Header from '@/components/Gallery/Header.vue';
  import Content from '@/components/Gallery/Content.vue';
  import Footer from '@/components/Footer.vue';
  export default {
    name: 'Gallery',
    components: {
      Navbar,
      Header,
      Content,
      Footer
    }
  }
  </script>
  
  <style scoped>
  
  </style>